const charsCounter = (node, event) => {
  const { target: input } = event;
  const maxChars = input.getAttribute('maxlength');
  node.innerHTML = `${parseInt(maxChars, 10) - input.value.length} characters remaining`;
};

const setCharsCountersListener = (nodes) => {
  nodes.forEach((node) => {
    const inputId = node.getAttribute('data-characters-counter-for-input');
    const input = document.getElementById(inputId);
    charsCounter(node, { target: input });
    input.addEventListener('input', charsCounter.bind(null, node));
  });
};

const removeCharsCountersListener = (nodes) => {
  nodes.forEach((node) => {
    const inputId = node.getAttribute('data-characters-counter-for-input');
    const input = document.getElementById(inputId);

    input.removeEventListener('input', charsCounter.bind(null, node));
  });
};

export default () => {
  const nodes = document.querySelectorAll('[data-characters-counter-for-input]');
  setCharsCountersListener(nodes);

  return () => {
    removeCharsCountersListener(nodes);
  };
};
